import { render, staticRenderFns } from "./SpecialVideoPop.vue?vue&type=template&id=36c99301&scoped=true&"
import script from "./SpecialVideoPop.vue?vue&type=script&lang=js&"
export * from "./SpecialVideoPop.vue?vue&type=script&lang=js&"
import style0 from "./SpecialVideoPop.vue?vue&type=style&index=0&id=36c99301&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c99301",
  null
  
)

export default component.exports